<template>
    <div>
        <base-header type="instore" class="advanced-promotions-header pb-6 pb-8 pt-5 pt-md-8"></base-header>

        <div class="container-fluid advanced-promotions-back-container">
            <div class="row ml-2 regular-header">
                <div class="col-auto" style="padding: 0px;">
                    <router-link :to="{ name: 'promotions_dashboard'}">
                        <h6 class="heading-small" style="color: white;"> ⟵   Back to Promo Dashboard </h6>
                    </router-link>
                </div>
            </div>
        </div>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card mb-3">
                        <promotions-table :promoType="id" :moduleId="moduleId"></promotions-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PromotionsTable from '../../views/Promotions/PromotionsTable'

    export default {
        components: {
            PromotionsTable
        },
        data() {
            return {
                id: this.$route.params.id.split("|")[0],
                moduleId:this.$route.params.id.split("|")[1]
            }
        },
        mounted: async function () {
            
        }
    }
</script>

<style scoped>
.advanced-promotions-header {
    height: clamp(360px, 25vh, 480px);
}
.advanced-promotions-back-container {
    margin-top: -136px;
    margin-bottom: 96px;
}
</style>
